import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { usePermissions } from '../../hooks/usePermissions';
import type { PermissionCheck } from '../../types/auth.types';

interface PermissionGuardProps {
    children: React.ReactNode;
    permission: PermissionCheck;
    fallback?: React.ReactNode;
    showFallback?: boolean;
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
    children,
    permission,
    fallback = <div className="text-mp-muted text-sm">Access denied</div>,
    showFallback = false,
}) => {
    const { user } = useAuth();
    const { hasPermission } = usePermissions();

    if (!user || !hasPermission(permission)) {
        return showFallback ? <>{fallback}</> : null;
    }

    return <>{children}</>;
};
